import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getAbsentDays = async (filter = {}) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/AbsentDay/get`,
      filter,
      {
        headers: getAuthHeader(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in getAbsentDays:", error);
    return {
      data: [],
      isSuccess: false,
      message: error.message
    };
  }
};

export const saveAbsentDay = async (model) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/AbsentDay/save`,
      model,
      {
        headers: getAuthHeader(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in saveAbsentDay:", error);
    return {
      success: false,
      message: error.message
    };
  }
}; 